import likeIcon from "@public/img/like.svg";
import dislikeIcon from "@public/img/dislike.svg";
import likeFillIcon from "@public/img/like-fill.svg";
import dislikeFillIcon from "@public/img/dislike-fill.svg";
import playIcon from "@public/img/play.svg";
import { Stats } from "@/entry/server/movie";
import React, { useState } from "react";
import { videoRepo } from "@/repo/video-repo";
import TrailerPlayerDialog from "@/pages-app/[type]/[id]/[slug]/_components/trailer-player-dialog";

type MovieLikesProps = {
    id: number;
    stats: Stats;
    is_liked: boolean;
    is_disliked: boolean;
    title: string;
    trailerUrl?: string;
    hasTrailer?: boolean;
};

export default function MovieLikes({
    id,
    stats,
    is_liked,
    is_disliked,
    title,
    trailerUrl,
    hasTrailer = false,
}: MovieLikesProps) {
    const [likes, setLikes] = useState(stats.likes);
    const [dislikes, setDislikes] = useState(stats.dislikes);
    const [loading, setLoading] = useState(false);
    const [openTrailer, setOpenTrailer] = useState(false);
    const [action, setAction] = useState<"like" | "dislike" | null>(
        is_liked ? "like" : is_disliked ? "dislike" : null
    );

    const handleLikeClick = async function (a: "like" | "dislike") {
        if (loading) return;
        if (action === a) return;

        if (a === "like") {
            setLikes(function (prev) {
                return prev + 1;
            });
            if (action === "dislike") {
                setDislikes(function (prev) {
                    return prev - 1;
                });
            }
        } else {
            setDislikes(function (prev) {
                return prev + 1;
            });
            if (action === "like") {
                setLikes(function (prev) {
                    return prev - 1;
                });
            }
        }

        setAction(a);
        setLoading(true);
        await videoRepo.likeMovie(id, a);
        setLoading(false);
    };

    var likesLabel = likes < 1000 ? String(likes) : Math.round(likes / 1000) + "K";
    var dislikesLabel = dislikes < 1000 ? String(dislikes) : Math.round(dislikes / 1000) + "K";

    return (
        <>
            <section className="movie-detail-likes container">
                <button
                    type="button"
                    className="movie-detail-likes__item"
                    onClick={function () {
                        handleLikeClick("like");
                    }}
                >
                    {loading && action === "like" ? (
                        <div className="loader" />
                    ) : (
                        <img src={action === "like" ? likeFillIcon : likeIcon} alt="" />
                    )}
                    <span>{"دوست داشتم (" + likesLabel + ")"}</span>
                </button>

                <span className="movie-detail-likes__divider" />

                <button
                    type="button"
                    className="movie-detail-likes__item"
                    onClick={function () {
                        handleLikeClick("dislike");
                    }}
                >
                    {loading && action === "dislike" ? (
                        <div className="loader" />
                    ) : (
                        <img src={action === "dislike" ? dislikeFillIcon : dislikeIcon} alt="" />
                    )}
                    <span>{"دوست نداشتم (" + dislikesLabel + ")"}</span>
                </button>

                {hasTrailer && (
                    <button
                        type="button"
                        className="movie-detail-likes__trailer"
                        onClick={function () {
                            setOpenTrailer(true);
                        }}
                    >
                        <img src={playIcon} alt="" />
                        مشاهده تریلر
                    </button>
                )}
            </section>

            {openTrailer && (
                <TrailerPlayerDialog
                    title={title}
                    trailerUrl={trailerUrl ? trailerUrl : ""}
                    onClose={function () {
                        setOpenTrailer(false);
                    }}
                />
            )}
        </>
    );
}
